import { VirtualTable } from "../../../components/tables";
import { TableRecordCountDisplayFooter } from "../../../components/tables/VirtualTable";
import useHubwiseJobs from "../hooks/useHubwiseJobs";
import HubwiseJobsTableHeader from "./HubwiseJobsTableHeader";
import HubwiseJobTableRow from "./HubwiseJobTableRow";

const HubwiseJobsTable = () => {

    const {
        results,
        sort,
        onClickSort,
        totalCount,
        hasData,
        isClearing,
        error,
        isItemLoaded,
        loadMore,
        reload
    } = useHubwiseJobs();

    return <VirtualTable
        enableScrollTracking
        loadMoreItems={loadMore}
        itemSize={42}
        itemCount={totalCount}
        itemData={hasData ? results : []}
        isItemLoaded={isItemLoaded}
        error={error}
        isLoading={isClearing}
        row={HubwiseJobTableRow}
        header={<HubwiseJobsTableHeader currentSort={sort} sortTable={onClickSort} />}
        footer={hasData && <TableRecordCountDisplayFooter
            totalCount={totalCount}
            isNewRecordsDisplayed={false}
            newRecordsSinceCache={0}
            reload={reload}
        />}
    />

}

export default HubwiseJobsTable;